import useGlossaryTerms from '@/hooks/api/v2/useGlossaryTerms';

export function useTableGlossaryTerms({ sectionId }) {
  return useGlossaryTerms({
    enabled: !!sectionId,
    extra_attributes: ['thumbnail_url'],
    params: { for_section: sectionId },
    placeholderData: [],
  });
}
